/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Report
 */
export interface Report {
  /**
   *
   * @type {string}
   * @memberof Report
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof Report
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof Report
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof Report
   */
  reportId: string;
  /**
   *
   * @type {ReportMethodEnum}
   * @memberof Report
   */
  method: ReportMethodEnum;
  /**
   *
   * @type {Date}
   * @memberof Report
   */
  beginDate: Date;
  /**
   *
   * @type {Date}
   * @memberof Report
   */
  endDate: Date;
  /**
   *
   * @type {string}
   * @memberof Report
   */
  groundwaterUsageFacilityBroId: string;
  /**
   *
   * @type {string}
   * @memberof Report
   */
  gpd: string;
  /**
   *
   * @type {string}
   * @memberof Report
   */
  dataOwner: string;
}

/**
 * @export
 */
export const ReportMethodEnum = {
  Berekening: "berekening",
  Watermeter: "watermeter",
  Onbekend: "onbekend",
} as const;
export type ReportMethodEnum = (typeof ReportMethodEnum)[keyof typeof ReportMethodEnum];

/**
 * Check if a given object implements the Report interface.
 */
export function instanceOfReport(value: object): value is Report {
  if (
    (!("reportId" in (value as Record<string, any>)) &&
      !("report_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["reportId"] === undefined &&
      (value as Record<string, any>)["report_id"] === undefined)
  )
    return false;
  if (!("method" in value) || value["method"] === undefined) return false;
  if (
    (!("beginDate" in (value as Record<string, any>)) &&
      !("begin_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["beginDate"] === undefined &&
      (value as Record<string, any>)["begin_date"] === undefined)
  )
    return false;
  if (
    (!("endDate" in (value as Record<string, any>)) &&
      !("end_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endDate"] === undefined &&
      (value as Record<string, any>)["end_date"] === undefined)
  )
    return false;
  if (
    (!("groundwaterUsageFacilityBroId" in (value as Record<string, any>)) &&
      !("groundwater_usage_facility_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["groundwaterUsageFacilityBroId"] === undefined &&
      (value as Record<string, any>)["groundwater_usage_facility_bro_id"] === undefined)
  )
    return false;
  if (!("gpd" in value) || value["gpd"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function ReportFromJSON(json: any): Report {
  return ReportFromJSONTyped(json, false);
}

export function ReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Report {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    reportId: json["report_id"],
    method: json["method"],
    beginDate: new Date(json["begin_date"]),
    endDate: new Date(json["end_date"]),
    groundwaterUsageFacilityBroId: json["groundwater_usage_facility_bro_id"],
    gpd: json["gpd"],
    dataOwner: json["data_owner"],
  };
}

export function ReportToJSON(json: any): Report {
  return ReportToJSONTyped(json, false);
}

export function ReportToJSONTyped(
  value?: Omit<Report, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    report_id: value["reportId"],
    method: value["method"],
    begin_date: value["beginDate"].toISOString().substring(0, 10),
    end_date: value["endDate"].toISOString().substring(0, 10),
    groundwater_usage_facility_bro_id: value["groundwaterUsageFacilityBroId"],
    gpd: value["gpd"],
    data_owner: value["dataOwner"],
  };
}
